import { render, staticRenderFns } from "./IconSvgHashTag.vue?vue&type=template&id=8568437c&scoped=true&"
import script from "./IconSvgHashTag.vue?vue&type=script&lang=js&"
export * from "./IconSvgHashTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8568437c",
  null
  
)

export default component.exports